<section class="dcl-base-modal" [ngClass]="{'no-title': !data.title}">
    <!-- Baymax header embedded mode -->
    <dcl-baymax-header
        class="dcl-baymax-header"
        *ngIf="data.showBaymaxHeader"
        [title]="data.title"
        [isCloseBtn]="false"
        [isModal]="true"
        [parent]="'.mat-dialog-container'"
        (iconEvent)="close()">
    </dcl-baymax-header>
    <span class="sr-only" translate>baseModal.startModal</span>
    <div class="header-section" *ngIf="!data.showBaymaxHeader">
        <div class="title-container" *ngIf="data.title" [ngClass]="{'logo-title': data.isTitleLogo}">
            <h1 class="title"
                [innerHTML]="data.title | translate">
            </h1>
            <div class="logo" role="img" [attr.aria-label]="data.title | translate"></div>
        </div>
        <button *ngIf="data.isClose"
            class="close-button teal-theme"
            (click)="close()">
            <i class="close-icon di di-close-reversed">
                <span class="sr-only">{{ 'baseModal.close' | translate }}</span>
            </i>
        </button>
    </div>

    <div class="description">
        <hr class="separator" *ngIf="!data.showBaymaxHeader && data.title">
        <div [innerHtml]="data.body | translate"></div>
    </div>

    <ng-template [ngIf]="data.buttons && data.buttons.length">
        <div class="actions">
            <ng-template ngFor [ngForOf]="data.buttons" let-button>
                <dcl-loading-content
                    class="loading-content"
                    [spinnerSize]="'small'"
                    [showSpinner]="button.spinner">
                    <wdpr-button
                        class="buttons"
                        [disabled]="isButtonDisabled"
                        [theme]="button.theme"
                        [translate]="button.text"
                        (click)="customFunction(button)"
                        (touchstart)="customFunction(button)">
                    </wdpr-button>
                </dcl-loading-content>
            </ng-template>
        </div>
    </ng-template>
</section>
